import RepositoryFactory from '@/repository/RepositoryFactory';
import { PutClassWorkplaceRequest } from '@/model/repository';
const shiftServiceRepositories = RepositoryFactory.shiftService;

/**
 * 持ち場を取得
 */
export async function fetchWorkplaces() {
  const fetchedWorkplaces = await shiftServiceRepositories.workplaces.index();
  return fetchedWorkplaces.data;
}

/**
 * 持ち場のクラスを保存
 */
export async function storeWorkplaceClass(id: string, payload: PutClassWorkplaceRequest) {
  const fetchedWorkplaceClasses = await shiftServiceRepositories.classWorkplace.update(id, payload);
  return fetchedWorkplaceClasses.data;
}

export default {
  fetchWorkplaces,
  storeWorkplaceClass,
};
